import React from 'react';
import { Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getFormattedSum } from 'common/helpers/numbers.helper';
import { ERoutesPrivate } from 'common/models/routesModel';
import { ReactComponent as BitecoinIcon } from 'app/assets/images/bitecoinIcon.svg';
import { ReactComponent as ExclamationMark } from 'app/assets/images/exclamationMark.svg';
import { useAppSelector } from 'app/store/store.hooks';
import { BITECOIN_AMOUNT_WARNING_PERCENT } from 'entities/Bitecoin/Bitecoin.const';

interface IComponentProps {
  onClick?: () => void;
}

export const BitecoinWallet: React.FC<IComponentProps> = ({ onClick }) => {
  const navigate = useNavigate();
  const { customerModel } = useAppSelector((state) => state.customer);
  const { bitecoinCustomerInfoModel } = useAppSelector((state) => state.bitecoin);

  if (!customerModel) {
    return null;
  }

  if (!bitecoinCustomerInfoModel) {
    return null;
  }

  const { bitecoins, bitecoinsLimit } = bitecoinCustomerInfoModel;
  const showWarning = bitecoins >= bitecoinsLimit * BITECOIN_AMOUNT_WARNING_PERCENT;

  const goToBitcoinPage = () => {
    navigate(ERoutesPrivate.Bitecoin);
    onClick && onClick();
  };

  return (
    <Row justify="center" align="middle" gutter={[8, 0]} onClick={goToBitcoinPage} className="bitecoin-wallet__wrapper">
      <BitecoinIcon />
      <span className="bitecoin-wallet__balance">{getFormattedSum(bitecoins)}</span>
      {showWarning && <ExclamationMark fill="#583f35" />}
    </Row>
  );
};
